module.exports = __webpack_public_path__ + "img/TJKL10.png";